import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import {
  EnrollmentNumberSetting,
  EnrollmentNumberSettingRequest,
} from '../entities/enrollment-number-setting.model';

/**
 * `/EnrollmentNumberSetting` (SchoolService, PR #50) — per-tenant registration
 * number mask. `GET` returns the effective mask (the tenant's, or the service
 * default) plus a rendered example; `PUT` validates and stores the tenant's
 * mask, echoing `isDefault: false`. Refusals use the 007 envelope (422) whose
 * `message` is already localized — surfaced verbatim, never re-mapped.
 */
@Injectable({ providedIn: 'root' })
export class EnrollmentNumberSettingService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<EnrollmentNumberSetting> {
    return this.http.get<EnrollmentNumberSetting>(`${this.baseUrl}/EnrollmentNumberSetting`, {
      withCredentials: true,
    });
  }

  public update(body: EnrollmentNumberSettingRequest): Observable<EnrollmentNumberSetting> {
    return this.http.put<EnrollmentNumberSetting>(`${this.baseUrl}/EnrollmentNumberSetting`, body, {
      withCredentials: true,
    });
  }
}
